export const server = "https://driveserver.appdeploy.in/api/v1";
// export const server = "http://192.168.88.249:5089/api/v1";

